export const habaCountries = {
  countries: {
    AL: 'Albania',
    AD: 'Andorra',
    BE: 'Belgium',
    BA: 'Bosnia and Herzegovina',
    BG: 'Bulgaria',
    DE: 'Germany',
    DK: 'Denmark',
    EE: 'Estonia',
    FI: 'Finland',
    FR: 'France',
    FO: 'Faroe Islands',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    VA: 'Holy See (Vatican City State)',
    IE: 'Ireland',
    IS: 'Iceland',
    IT: 'Italy',
    HR: 'Croatia',
    LV: 'Latvia',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MT: 'Malta',
    MK: 'Macedonia',
    MD: 'Moldova',
    MC: 'Monaco',
    ME: 'Montenegro',
    NL: 'Netherlands',
    NO: 'Norway',
    PL: 'Poland',
    PT: 'Portugal',
    RO: 'Romania',
    RU: 'Russian Federation',
    SM: 'San Marino',
    SE: 'Sweden',
    CH: 'Switzerland',
    RS: 'Serbia',
    SK: 'Slovakia',
    SI: 'Slovenia',
    ES: 'Spain',
    CZ: 'Czech Republic',
    TR: 'Turkey',
    UA: 'Ukraine',
    HU: 'Hungary',
    BY: 'Belarus',
    CY: 'Cyprus',
    AT: 'Austria',
  },
  languages: {
    en: 'English',
    de: 'German',
    ch: 'Swiss German',
    fr: 'French',
  },
};
